import React, { useState } from "react";
import Datetime from "react-datetime";
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";
import { setSelected } from "../redux/notificationsSagas";
import { CFormText } from "@coreui/react";

export function isStartDateGreaterThanEndDate(startDateStr, endDateStr, hasEndDate) {
  if (!hasEndDate) {
    return false;
  }
  const startDate = moment(startDateStr, "MM/DD/YYYY hh:mm A");
  const endDate = moment(endDateStr, "MM/DD/YYYY hh:mm A");

  return startDate.isAfter(endDate);
}

const Schedule = () => {
  const dispatch = useDispatch();
  const {
    selected: { start_on, end_on }
  } = useSelector((state) => state.notifications);

  const handleDateTimeChange = (dateObj, property) => {
    let date = moment(dateObj).format("MM/DD/YYYY");
    let time = moment(dateObj).format("hh:mm A");

    if (property === "start-date") {
      dispatch(
        setSelected({
          start_on: `${date} ${moment(start_on, "MM/DD/YYYY hh:mm A").format("hh:mm A")}`
        })
      );
    } else if (property === "start-time") {
      dispatch(
        setSelected({
          start_on: `${moment(start_on, "MM/DD/YYYY hh:mm A").format("MM/DD/YYYY")} ${time}`
        })
      );
    } else if (property === "end-date") {
      dispatch(
        setSelected({ end_on: `${date} ${moment(end_on, "MM/DD/YYYY hh:mm A").format("hh:mm A")}` })
      );
    } else if (property === "end-time") {
      dispatch(
        setSelected({
          end_on: `${moment(end_on, "MM/DD/YYYY hh:mm A").format("MM/DD/YYYY")} ${time}`
        })
      );
    }
  };
  const setDefaultData = (fieldName, value) => {
    dispatch(
      setSelected({
        [fieldName]: value
      })
    );
  };

  const removeSelectedData = (fieldName) => {
    dispatch(
      setSelected({
        [fieldName]: null
      })
    );
  };

  const yesterday = moment().subtract(1, "day");
  const disablePastDates = (current) => {
    return current.isAfter(yesterday);
  };

  return (
    <>
      <div className="notifications__section light">
        <div className="notifications__section__date">
          <p>Start on</p>

          {!start_on ? (
            <span
              title={"Click to select date"}
              className={"pointer-cursor"}
              onClick={() =>
                setDefaultData(
                  "start_on",
                  moment()
                    .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
                    .format("MM/DD/YYYY hh:mm A")
                )
              }
            >
              Select date
            </span>
          ) : (
            <>
              <Datetime
                dateFormat={"MM/DD/YYYY"}
                isValidDate={disablePastDates}
                value={moment(start_on, "MM/DD/YYYY hh:mm A").toDate()}
                onChange={(dateObj) => handleDateTimeChange(dateObj, "start-date")}
                timeFormat={false}
                inputProps={{ readOnly: true }}
              />

              <Datetime
                value={moment(start_on, "MM/DD/YYYY hh:mm A").toDate()}
                onChange={(dateObj) => handleDateTimeChange(dateObj, "start-time")}
                dateFormat={false}
                inputProps={{ readOnly: true }}
              />
              <span
                title={"reset date"}
                className="close-icon"
                onClick={() => removeSelectedData("start_on")}
              >
                &times;
              </span>
            </>
          )}
        </div>
      </div>
      <div className="notifications__section light">
        <div className="notifications__section__date">
          <p>End on</p>
          {!end_on ? (
            <span
              title={"Click to select date"}
              className={"pointer-cursor"}
              onClick={() =>
                setDefaultData(
                  "end_on",
                  moment()
                    .set({ hour: 47, minute: 0, second: 0, millisecond: 0 })
                    .format("MM/DD/YYYY hh:mm A")
                )
              }
            >
              Select date
            </span>
          ) : (
            <>
              <Datetime
                dateFormat={"MM/DD/YYYY"}
                isValidDate={disablePastDates}
                value={moment(end_on, "MM/DD/YYYY hh:mm A").toDate()}
                onChange={(dateObj) => handleDateTimeChange(dateObj, "end-date")}
                timeFormat={false}
                inputProps={{ readOnly: true }}
              />
              <Datetime
                value={moment(end_on, "MM/DD/YYYY hh:mm A").toDate()}
                onChange={(dateObj) => handleDateTimeChange(dateObj, "end-time")}
                dateFormat={false}
                inputProps={{ readOnly: true }}
              />
              <span
                title={"reset date"}
                className="close-icon"
                onClick={() => removeSelectedData("end_on")}
              >
                &times;
              </span>
            </>
          )}
        </div>
      </div>
      <CFormText className="help-block">
        {isStartDateGreaterThanEndDate(start_on, end_on, !!end_on)
          ? "Start on date should be less than End on date"
          : ""}
      </CFormText>
    </>
  );
};
export default Schedule;
